import React, { lazy } from 'react';
var AKSpinner = /*#__PURE__*/lazy(function () {
  return import('@atlaskit/spinner');
});
export var Spinner = function Spinner(_ref) {
  var _forgeDoc$props;
  var forgeDoc = _ref.forgeDoc;
  return /*#__PURE__*/React.createElement(AKSpinner, {
    size: (_forgeDoc$props = forgeDoc.props) === null || _forgeDoc$props === void 0 ? void 0 : _forgeDoc$props.size
  });
};